import React from 'react';
import OpenBar from './OpenBar';
import { v4 as uuidv4 } from 'uuid';
import './Quest.scss';

const FAQs = ({ faqs, faqsRef }) => (
  <div className="faqSection">
    <div className='common_title'>FAQs</div>{' '}
    {faqs.map(faqItem => (
      <OpenBar
        description={faqItem.description}
        key={uuidv4()}
        title={faqItem.title}
      />
      ))}{' '}
    <div ref={faqsRef} />
  </div>
);

export default FAQs;
